exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".up-box[data-v-0f33fb08]{display:flex}.up-box img[data-v-0f33fb08]{width:360px;height:180px;margin-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0f33fb08&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/UploadImg.vue
// module id = 441
// module chunks = 0